import React from "react";
import Sidebar from "./Sidebar";
import {
  Card,
  Col,
  Container,
  Row,
  Button,
  Tab,
  Nav,
  Table,
} from "react-bootstrap";
import Piechart from "./Piechart";
import DashboardHeader from "./directives/DashboardHeader";
import "./css/projectoverview.css";

const ProjectOverview = ({ special, clearModalData }) => {
  const data = [
    { detail: "Private Sale", percentage: "5%", quantity: "50,000,000" },
    { detail: "Pre Sale", percentage: "10%", quantity: "50,000,000" },
    { detail: "Public Sale", percentage: "15%", quantity: "50,000,000" },
    { detail: "Marketing", percentage: "20%", quantity: "50,000,000" },
    { detail: "Referral", percentage: "5%", quantity: "50,000,000" },
    { detail: "R & D", percentage: "12%", quantity: "50,000,000" },
    { detail: "Airdrop", percentage: "18%", quantity: "50,000,000" },
    { detail: "Liquidity Staking", percentage: "6%", quantity: "50,000,000" },
    { detail: "Ecosystem", percentage: "17%", quantity: "50,000,000" },
    { detail: "Reserve", percentage: "14%", quantity: "50,000,000" },
    { detail: "Charity", percentage: "4%", quantity: "50,000,000" },
  ];

  return (
    <>
      <div
        className="w-100 d-grid"
        style={{ minHeight: "100vh", overflow: "hidden" }}
      >
        <div className="d-flex  w-100 h-100">
          <div
            className="position-relative"
            style={{ borderRight: "1px solid rgba(255, 255, 255, 0.15)" }}
          >
            <Sidebar special={special} clearModalData={clearModalData} />
          </div>

          <div className="w-100" style={{ height: "100%" }}>
            <DashboardHeader />
            <div className="subheader">
              <img
                src="assets/images/dashboard/banner/innerbanner.svg"
                className="w-100"
              />
            </div>
            <div
              className="px-4 px-lg-4"
              style={{
                // padding: "15px",
                flex: "1",
                backgroundColor: "#00021F",
                color: "#ffffff",
                height: "100%",
                overflowY: "auto",
              }}
            >
              <Row className="">
                <Col xxl={12}>
                  <div className="heading py-4">
                    <h4 className="mb-0">Axverse</h4>
                    <p className="my-3 fw-light text-light-grey">
                      http://axverse.in/
                    </p>
                    <div className="text-white fw-normal">
                      Infiltrate, survive, and restore balance to reclaim our
                      world.
                    </div>
                  </div>
                </Col>
                <Col xxl={8} xl={8} className="mb-4">
                  <Card className="dashboard-card d-flex overflow-hidden gap-3 bg-grey">
                    <div className="tabStyle3">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="projectoverview"
                      >
                        <Row>
                          <Col sm={12} className="mb-1">
                            <Nav variant="pills" className="">
                              <Nav.Item className="w-50 text-center">
                                <Nav.Link
                                  eventKey="projectoverview"
                                  className="me-0"
                                >
                                  Project Overview
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="w-50 text-center">
                                <Nav.Link
                                  eventKey="tokenomics"
                                  className="me-0"
                                >
                                  Tokenomics
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </Col>
                          <Col sm={12}>
                            <Tab.Content>
                              <Tab.Pane eventKey="projectoverview">
                                <Card.Body className="position-relative">
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <div className="text-light-grey small">
                                        Total Raise
                                      </div>
                                      <div className="text-white small">
                                        $250,000
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Token Price
                                      </div>
                                      <div className="text-white small">
                                        $0.521
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Start Date
                                      </div>
                                      <div className="text-white small">
                                        TBA
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Type
                                      </div>
                                      <div className="text-white small">
                                        Standard IDO
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        End Date
                                      </div>
                                      <div className="text-white small">
                                        TBA
                                      </div>
                                    </div>
                                  </div>
                                </Card.Body>
                                <hr className="my-1" />
                                <Card.Body className="position-relative">
                                  <div>
                                    <h6 className="text-white">Summary</h6>
                                    <p className="text-light-grey fw-light">
                                      A highlight of Axverse is its gamified
                                      economy: players can buy loot boxes
                                      containing randomized rewards, driving
                                      user engagement and creating a dynamic
                                      in-game economy. Additionally, GPT Wars
                                      introduces a deflationary token model with
                                      Axverse, where in-game purchases are
                                      priced in USDT, and a portion of the
                                      revenue is allocated to buying back and
                                      burning the token. This structure helps
                                      maintain token scarcity, supporting
                                      long-term value while creating a
                                      sustainable and rewarding ecosystem for
                                      players and investors alike.
                                    </p>
                                  </div>

                                  <div className="">
                                    <Button
                                      variant="primary-gradient"
                                      className=" border-0 px-4 small"
                                    >
                                      View Whitepaper
                                    </Button>
                                  </div>
                                </Card.Body>
                              </Tab.Pane>
                              <Tab.Pane eventKey="tokenomics">
                                <Card.Body className="position-relative">
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <div className="text-light-grey small">
                                        Total Raise
                                      </div>
                                      <div className="text-white small">
                                        $250,000
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Token Price
                                      </div>
                                      <div className="text-white small">
                                        $0.521
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Start Date
                                      </div>
                                      <div className="text-white small">
                                        TBA
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Type
                                      </div>
                                      <div className="text-white small">
                                        Standard IDO
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        End Date
                                      </div>
                                      <div className="text-white small">
                                        TBA
                                      </div>
                                    </div>
                                  </div>
                                </Card.Body>
                                <hr className="my-1" />
                                <Card.Body className="position-relative pb-0">
                                  <Row>
                                    <Col lg={6} className="mb-3">
                                      <div>
                                        <Piechart />
                                      </div>
                                    </Col>
                                    <Col lg={6} className="mb-3">
                                      <div className="tabStyle">
                                        <Table responsive className="mb-0">
                                          <thead>
                                            <tr>
                                              <th>Details</th>
                                              <th>%(Ptg.)</th>
                                              <th>Token Quantity</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {data.map((row, index) => (
                                              <tr key={index}>
                                                <td>{row.detail}</td>
                                                <td>{row.percentage}</td>
                                                <td>{row.quantity}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Tab.Pane>
                            </Tab.Content>
                          </Col>
                        </Row>
                      </Tab.Container>
                    </div>
                  </Card>
                </Col>
                <Col xxl={4} xl={4} className="mb-4">
                  <Card className="dashboard-card gap-0 overflow-hidden bg-grey">
                    <Card.Header className="text-center">
                      Join the Community
                    </Card.Header>
                    <Card.Body className=" position-relative">
                      <p className="small text-light-grey">
                        Keep up with the Axverse project & it’s progress in
                        their telegram community channel
                      </p>

                      <div className="text-center mt-4">
                        <Button
                          variant="outline-blue"
                          className=" px-4 small mb-4"
                        >
                          <span className="me-1">
                            <img
                              src="assets/images/dashboard/icon/telegram.png"
                              width={`20px`}
                              height={`20px`}
                            />{" "}
                          </span>
                          Join the community
                        </Button>
                        <Button
                          variant="default"
                          className="w-100 border-0 small px-4"
                        >
                          May be Later
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
            <br/>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectOverview;
